import React from 'react';
import {
  Switch, Redirect, useRouteMatch,
} from 'react-router-dom';

import ProtectedRoute from './ProtectedRoute';
import LetterConfirm from '../components/Steps/Letter/LetterConfirm';
import LetterView from '../components/Steps/Letter/LetterView';
import PendingLetter from '../components/Steps/Letter/PendingLetter';

const LetterRouter = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <ProtectedRoute exact path={path}>
        <LetterView />
      </ProtectedRoute>
      <ProtectedRoute path={`${path}/pending`}>
        <PendingLetter />
      </ProtectedRoute>
      <ProtectedRoute path={`${path}/confirm`}>
        <LetterConfirm />
      </ProtectedRoute>
      <Redirect to={path} />
    </Switch>
  );
};

export default LetterRouter;
